import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { CacheService } from './cacheInterface';

@Injectable({
  providedIn: 'root'
})
export class ClientCacheService implements CacheService {

  public get(key: string) {
    return of(null);
  }

  public set(key: string, value: string, expiration?: number) {
  }
}
